import React from 'react'
import { StyledAside } from './styledComponents'

const Aside = ({ children }) => {
  return <StyledAside>{children}</StyledAside>
}

export default Aside
